import urlHelper from '@common-libs/utils/url-helper'
import { getPlatform } from '@common-libs/tj-utils/platform'
import { channelTypes, getChannelInfo } from '@common-libs/tj-channel'
const {
  isTujiaAppEnv, // 途家 APP
  isCtripAppEnv, // 携程 APP
  isQunarAppEnv, // 去哪儿 APP
  isMayiAppEnv, // 蚂蚁 APP
  isElongAppEnv, // 艺龙 APP
  isTongchengAppEnv, // 同程APP
  isTEAppEnv, // 同程 艺龙APP
  isJdAppEnv, // 京东 APP
  isWxEnv, // 微信环境
  isAliEnv, // 支付宝环境
  isWxMpEnv, // 微信小程序
  isAliMpEnv, // 支付宝小程序
  isBaiduMpEnv, // 百度小程序
  isTouTiaoMpEnv, // 头条小程序
  isGaoDeMpEnv, // 高德小程序
  isTCQMEAppEnv, // 四方 APP
  isBrowserEnv, // 普通浏览器环境
  isMpEnv, // 微信小程序 百度小程序 支付宝小程序 头条小程序
  isQuickMpEnv, // 途家快应用小程序
  isCtripTongAppEnv, // 携程通app
  isCtripTongH5Env, // 携程通H5
  isKuaiShouMpEnv // 快手小程序
} = getPlatform()
const PLAYTFORM_TYPE = {
  ALI_ENV: isAliEnv,
  ALI_MP_ENV: isAliMpEnv,
  AMAP_MP_ENV: isGaoDeMpEnv,
  BAIDU_MP_ENV: isBaiduMpEnv,
  BROWSER_ENV: isBrowserEnv,
  CTRIP_APP_ENV: isCtripAppEnv,
  JD_APP_ENV: isJdAppEnv,
  MAYI_APP_ENV: isMayiAppEnv,
  QUICK_MP_ENV: isQuickMpEnv,
  QUNAR_APP_ENV: isQunarAppEnv,
  TT_MP_ENV: isTouTiaoMpEnv,
  TUJIA_APP_ENV: isTujiaAppEnv,
  WX_ENV: isWxEnv,
  WX_MP_ENV: isWxMpEnv,
  CTRIPTONG_APP_ENV: isCtripTongAppEnv,
  KUAI_SHOU_MP_ENV: isKuaiShouMpEnv
}
const pwaGlobalConfig = {
  env: {
    // 普通浏览器环境
    isBrowser: isBrowserEnv,
    // 途家APP环境
    isTujiaApp: isTujiaAppEnv,
    // 微信APP环境
    isWechatWeb: isWxEnv,
    // 微信小程序环境
    isWechatMp: isWxMpEnv,
    // 支付宝环境
    isAliWeb: isAliEnv,
    // 支付宝小程序环境
    isAliMp: isAliMpEnv,
    // 京东APP环境
    isJDApp: isJdAppEnv,
    // 去哪儿APP环境
    isQunarApp: isQunarAppEnv,
    // 携程APP环境
    isCtripApp: isCtripAppEnv,
    // 蚂蚁APP环境
    isMayiApp: isMayiAppEnv,
    // 高德小程序环境
    isAmapMp: isGaoDeMpEnv,
    // 百度小程序环境
    isBaiduMp: isBaiduMpEnv,
    // 去哪儿WEB环境
    isQunarWeb: urlHelper.queryString('mref') === 'qunar',
    // 头条小程序
    isTtMp: isTouTiaoMpEnv,
    // 同程、艺龙App环境
    isTEApp: isTEAppEnv,
    // 同程App环境
    isTongchengApp: isTongchengAppEnv,
    // 艺龙App环境
    isElongApp: isElongAppEnv,
    // 四方 APP
    isTCQMEApp: isTCQMEAppEnv,
    // 微信小程序 百度小程序 支付宝小程序 头条小程序
    isMpEnv,
    // 途家快应用小程序
    isQuickMpEnv,
    // 携程通app
    isCtripTongAppEnv,
    // 携程通H5
    isCtripTongH5Env,
    // 快手小程序
    isKuaiShouMpEnv
  },
  getBrandsName() {
    // 蚂蚁短租
    if (this.env.isMayiApp || this.env.isMayiMp) {
      return '蚂蚁短租'
    }
    // 去哪儿
    if (this.env.isQunarApp || this.env.isQunarWeb) {
      return '去哪儿旅行'
    }
    return '途家民宿'
  },
  getPlatformType() {
    return Object.keys(PLAYTFORM_TYPE).find((i) => PLAYTFORM_TYPE[i]) || 'NULL'
  }
}

/**
 * 设置平台ID
 * ！！！废弃 与channelid冲突混淆
 */
// function setPlatFormId() {
//   let _platformId = tjCookie.getTujiaPlatformId()
//   const _queryPlatform = urlHelper.queryString('tjptid')
//   // query 与 cookie 都有值且不相等，用query覆盖cookie
//   if (_platformId && _queryPlatform && _platformId !== _queryPlatform) {
//     _platformId = _queryPlatform
//   }

//   // cookie 没有值，首次进入，把 query 写入 cookie
//   if (!_platformId && _queryPlatform) {
//     _platformId = _queryPlatform
//   }

//   // 没有 cookie 和 query, 用app ua识别
//   if (!_platformId) {
//     _platformId =
//       (pwaGlobalConfig.env.isCtripApp && 'ctrip') ||
//       (pwaGlobalConfig.env.isTujiaApp && 'tujia') ||
//       (pwaGlobalConfig.env.isQunarApp && 'qunar') ||
//       (pwaGlobalConfig.env.isMayiApp && 'mayi') ||
//       'tujia'
//   }
//   console.log('_platformId', _platformId)
//   tjCookie.setTujiaPlatformId(_platformId)
// }

// // 兼容以前的逻辑
// if (tjCookie.getTujiaPlatformId() === 'mayi') {
//   document.body.className = 'useMayiLoading'
// }

// setPlatFormId()

const { channelId } = getChannelInfo()
// 微信小程序环境
if (pwaGlobalConfig.env.isWechatMp) {
  pwaGlobalConfig.env.isTujiaMp = channelId === channelTypes.TUJIA
  pwaGlobalConfig.env.isCtripMp = channelId === channelTypes.CTRIP
  pwaGlobalConfig.env.isQunarMp = channelId === channelTypes.QUNAR
  pwaGlobalConfig.env.isElongMp = channelId === channelTypes.ELONG
  pwaGlobalConfig.env.isMayiWechatMp = channelId === channelTypes.MAYI
  pwaGlobalConfig.env.isMayiMp = pwaGlobalConfig.env.isMayiWechatMp
  // ctrip/qunar/elong小程序
  pwaGlobalConfig.env.isCQEMp = pwaGlobalConfig.env.isCtripMp || pwaGlobalConfig.env.isQunarMp || pwaGlobalConfig.env.isElongMp
}
// 支付宝小程序环境识别
if (pwaGlobalConfig.env.isAliMp) {
  pwaGlobalConfig.env.isMayiAliMp = channelId === channelTypes.MAYI
  pwaGlobalConfig.env.isMayiMp = pwaGlobalConfig.env.isMayiAliMp
  pwaGlobalConfig.env.isCtripAliMp = channelId === channelTypes.CTRIP
}
if (pwaGlobalConfig.env.isMayiMp) {
  document.body.className = 'useMayiLoading'
}

// 更新fas site拓展字段
window.addEventListener('onFasInit', () => {
  window._fas.setSiteExt({
    channel: channelId,
    platform: pwaGlobalConfig.getPlatformType()
  })
})

console.log('pwaGlobalConfig', pwaGlobalConfig)
export default pwaGlobalConfig
